import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Playsquare;
import Playsquare from '@crehana/compass.icons.outline/Playsquare';
import { Button, cn } from '@crehana/compass.ui/v2';
import useCollaboratorTranslation from "../../hooks/useCollaboratorTranslation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MainCategoryCard = function MainCategoryCard(_ref) {
  var _defaultColors$cta, _defaultColors$cta2, _defaultColors$cta3;
  var title = _ref.title,
    ctaText = _ref.ctaText,
    className = _ref.className,
    coursesCount = _ref.coursesCount,
    defaultColors = _ref.defaultColors,
    style = _ref.style,
    onCTAClick = _ref.onCTAClick;
  var _useCollaboratorTrans = useCollaboratorTranslation(),
    t = _useCollaboratorTrans.t,
    languageCode = _useCollaboratorTrans.languageCode;
  var hasOrgStyle = Boolean(style === null || style === void 0 ? void 0 : style.background);
  var formattedCoursesCount = coursesCount.toLocaleString(languageCode, {
    useGrouping: true
  });
  var ctaVariant = (defaultColors === null || defaultColors === void 0 ? void 0 : (_defaultColors$cta = defaultColors.cta) === null || _defaultColors$cta === void 0 ? void 0 : _defaultColors$cta.variant) || (hasOrgStyle ? 'white' : 'primary');
  return /*#__PURE__*/_jsxs("article", {
    className: cn('tw-w-24 sm:tw-w-full tw-rounded-2 tw-overflow-hidden',
    // Flex
    'tw-flex tw-flex-col tw-items-start tw-justify-end',
    // Padding
    'tw-p-1.6', hasOrgStyle ? 'tw-text-neutral-light-100' : 'tw-text-primary-light-700', defaultColors === null || defaultColors === void 0 ? void 0 : defaultColors.background, className),
    style: _objectSpread({}, style),
    "aria-label": title,
    children: [/*#__PURE__*/_jsx("h3", {
      className: cn('tw-font-subtitle1 tw-mt-0 tw-mb-0.8', defaultColors === null || defaultColors === void 0 ? void 0 : defaultColors.foreColor),
      children: title
    }), /*#__PURE__*/_jsxs("p", {
      className: cn('tw-flex tw-items-center tw-font-body3 tw-mb-1.2 tw-mt-0', defaultColors === null || defaultColors === void 0 ? void 0 : defaultColors.foreColor),
      children: [_Playsquare || (_Playsquare = /*#__PURE__*/_jsx(Playsquare, {
        className: "tw-w-2.4 tw-min-w-2.4 tw-mr-0.4"
      })), formattedCoursesCount, ' ', t(coursesCount > 1 ? 'KH_CONTENTS_CATEGORY_LABEL' : 'KH_CONTENT_CATEGORY_LABEL')]
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      onClick: onCTAClick,
      className: cn(defaultColors === null || defaultColors === void 0 ? void 0 : (_defaultColors$cta2 = defaultColors.cta) === null || _defaultColors$cta2 === void 0 ? void 0 : _defaultColors$cta2.foreColor, defaultColors === null || defaultColors === void 0 ? void 0 : (_defaultColors$cta3 = defaultColors.cta) === null || _defaultColors$cta3 === void 0 ? void 0 : _defaultColors$cta3.background),
      variant: ctaVariant,
      style: {
        color: style !== null && style !== void 0 && style.background ? String(style === null || style === void 0 ? void 0 : style.background) : undefined
      },
      children: ctaText
    })]
  });
};
export default MainCategoryCard;